export default "__VITE_ASSET__CdsW5_3h__"